import Box from '@mui/material/Box';
import ModalBase from "./ModalBase";
import TextButton from "../Buttons/TextButton";
import DeleteIcon from '../Icons/js/icons/DeleteIcon'
import Text from '../Text'

/**
 * Modal UI Component to ask the user confirms changes they made in editing mode
 * @param open open state
 * @param setOpen open state
 * @param onSubmit onSubmit function
 * @param children
 */
export default function DeleteConfirmationModal({open, setOpen, onSubmit, children}){
    const closeHandler = () => { setOpen(false) };
    const saveHandler = () => {
        onSubmit();
        setOpen(false);
    };

    return(
        <ModalBase open={open} setOpen={setOpen} sx={{ minWidth: '350px !important' }}>
            <Box>
                <Box sx={(theme) => ({
                    alignItems: 'center',
                    borderBottom: `3px solid ${theme.palette.primary.accent}`,
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '10px 0'
                })}>
                    <Box sx={(theme) => ({
                        margin: '0 10px 0 0',
                        '& *': { fill: theme.palette.primary.accent }
                    })}>
                        <DeleteIcon />
                    </Box>
                    <Text type={'h2'}>Delete Selected</Text>
                </Box>
                <Box sx={{
                    margin: '20px auto',
                    maxWidth: 300,
                    '& *': { textAlign: 'center' }
                }}>
                    <Text>Are you sure you want to delete selected item from your data?</Text>
                </Box>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    margin: '36px 20px 20px 0',
                    '& button': { marginLeft: '20px' }
                }}>
                    <TextButton clickHandler={closeHandler} secondaryButton>No</TextButton>
                    <TextButton clickHandler={saveHandler} >Yes</TextButton>
                </Box>
            </Box>
        </ModalBase>
    )
}
